import { render, staticRenderFns } from "./EditFarm.vue?vue&type=template&id=c80f0d40&scoped=true&"
import script from "./EditFarm.vue?vue&type=script&lang=js&"
export * from "./EditFarm.vue?vue&type=script&lang=js&"
import style0 from "./EditFarm.vue?vue&type=style&index=0&id=c80f0d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80f0d40",
  null
  
)

export default component.exports